import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useSchedMainInfoForm from "./useSchedMainInfoForm";
import TextField from "../../../ui/TextField";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import Scheduler from 'devextreme-react/scheduler';
import { tempschedule } from './tempschedule.js';

const defaultData = {
  name: "",
  programName: "",
  programType: "",
  formType: "",
  orderNumber: "",
  period: "",
  state: "",
  competence: "",
  profName:""
};

const styles = () => ({
  root: {
    width: "100%",
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  schedContainer:{
    width: "100%",
    paddingTop: "16px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  }
});

const SchedViewMainInfo = ({ initialData, classes }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const { dataSources, getSchedMainInfoForm } = useSchedMainInfoForm();
  const {
    name,
    programName,
    programType,
    formType,
    orderNumber,
    period,
    state,
    competence,
    profName
  } = data;

  useEffect(() => {
    getSchedMainInfoForm();
  }, []);

  const views = ['week', 'month'];

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={8}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <TextField
                value={programName}
                label="Рабочая программа"
                readOnly={true} hoverStateEnabled={false}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={formType}
                label="Форма обучения"
                readOnly={true} hoverStateEnabled={false}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={period}
                label="Период действия"
                readOnly={true} hoverStateEnabled={false}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <TextField
                value={orderNumber}
                label="Заказчик"
                readOnly={true} hoverStateEnabled={false}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={orderNumber}
                label="Номер заказа"
                readOnly={true} hoverStateEnabled={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className={classes.schedContainer}>
        <Scheduler
                dataSource={tempschedule}
                views={views}
                defaultCurrentView="week"
                height={600}
                startDayHour={9} />
      </div>
    </div>
  );
};

export default withStyles(styles)(SchedViewMainInfo);
